// extracted by mini-css-extract-plugin
export var actionButton = "_y2-2";
export var card = "_y2-0";
export var errorCard = "_y2-1";